import { setDurationControlDisabled, setDurationControlValue } from '../shared/duration-control.js';
import { pledgePayBodyFromShell, pledgePayUiRoot } from './pledge-pay-utils';

const PENDING_RECURRING_CLASS = 'pledge-pay-panel--pending-recurring';

function pendingRecurringPlan(pledges) {
    if (!Array.isArray(pledges) || pledges.length !== 1) {
        return null;
    }
    return pledges[0]?.pending_recurring || null;
}

function setPlanFrequency($body, frequencyId) {
    const $option = $body.find('select[name="frequency"] option[id="' + frequencyId + '"]');
    if (!$option.length) {
        return;
    }
    $body.find('select[name="frequency"]').val($option.attr('value'));
}

function lockPlanFields($body, plan) {
    setPlanFrequency($body, plan.frequency_id);
    const duration = $body.find('#pledge_payment_duration').get(0);
    if (duration) {
        setDurationControlValue(duration, plan.duration);
        setDurationControlDisabled(duration, true);
    }
    $body.find('select[name="frequency"]').prop('disabled', true);
    $body.find('input[name="pledge_start_date"]').val(plan.start_date).prop('disabled', true);
    $body.find('#run_today').prop('checked', plan.starts_on_activation).prop('disabled', true);
    $body.find('.recurring-setup-col--check').hide();
    $body.find('.pledge-schedule-start-datepicker')
        .closest('.recurring-setup-col')
        .toggle(!plan.starts_on_activation);
    syncPendingRecurringCashMethod($body);
    setStartScheduleButton($body, plan);
}

function setStartScheduleButton($body, plan) {
    if (plan.starts_on_activation) {
        return;
    }
    const $btn = $body.find('#pay_now_button');
    const $inner = $btn.find('.mgr-pay-btn-inner');
    if ($inner.length) {
        $inner.text('Confirm and Start Schedule');
        return;
    }
    if ($btn.length) {
        $btn.text('Start Schedule');
    }
}

function clearSelectedCashMethod($body) {
    const $cashRadio = $body.find('input[name="mgr_pledge_payment_method_pref"][value="check_cash"]');
    if (!$cashRadio.prop('checked')) {
        return;
    }
    $cashRadio.prop('checked', false);
    $body.find('input[name="mgr_pledge_payment_method_pref"][value="online"]').prop('checked', true);
    $body.find('.mark_paid_div').hide().addClass('pledge-pay-hidden');
    const $btn = $body.find('#pay_now_button');
    const $inner = $btn.find('.mgr-pay-btn-inner');
    if ($inner.length) {
        return;
    }
    if ($btn.text() === 'Apply Payment') {
        $btn.text('Make Payment');
    }
}

function syncPendingRecurringCashMethod($body) {
    const blockCash = $body.hasClass(PENDING_RECURRING_CLASS);
    const $cashRadio = $body.find('input[name="mgr_pledge_payment_method_pref"][value="check_cash"]');
    const $cashPill = $body.find('[data-mgr-pledge-method-pill="check_cash"]');
    if (!$cashRadio.length && !$cashPill.length) {
        return;
    }
    if (blockCash) {
        clearSelectedCashMethod($body);
    }
    $cashRadio.prop('disabled', blockCash);
    $cashPill.prop('disabled', blockCash).toggleClass('is-disabled', blockCash).toggle(!blockCash);
    const $switcher = $body.find('.payment-method-switcher').first();
    if (!$switcher.length) {
        return;
    }
    const visiblePills = $switcher.find('[data-mgr-pledge-method-pill]').filter(function () {
        return this.style.display !== 'none';
    }).length;
    $switcher.toggle(visiblePills > 1);
}

function unlockPlanFields($body) {
    const duration = $body.find('#pledge_payment_duration').get(0);
    if (duration) {
        setDurationControlDisabled(duration, false);
    }
    $body.find('select[name="frequency"]').prop('disabled', false);
    $body.find('input[name="pledge_start_date"]').prop('disabled', false);
    $body.find('#run_today').prop('disabled', false);
    $body.find('.recurring-setup-col--check, .pledge-schedule-start-datepicker')
        .closest('.recurring-setup-col')
        .show();
    syncPendingRecurringCashMethod($body);
}

function forceRecurringMode($body) {
    $body.find('#payment_mode').val('recurring');
    $body.find('#recurring_payment').prop('checked', true).closest('label').addClass('active');
    $body.find('#full_payment').prop('checked', false).closest('label').removeClass('active');
    $body.find('#recurring_div').removeClass('pledge-pay-hidden').show();
}

function applyPendingRecurringMode($container, pledges) {
    const $body = pledgePayBodyFromShell(pledgePayUiRoot($container));
    const plan = pendingRecurringPlan(pledges);

    $body.toggleClass(PENDING_RECURRING_CLASS, !!plan);
    $body.find('.payment_type').toggle(!plan);

    if (!plan) {
        unlockPlanFields($body);
        return false;
    }

    forceRecurringMode($body);
    lockPlanFields($body, plan);

    return true;
}

function isPendingRecurringPayBody($container) {
    const $body = pledgePayBodyFromShell(pledgePayUiRoot($container));
    return $body.hasClass(PENDING_RECURRING_CLASS);
}

export {
    applyPendingRecurringMode,
    isPendingRecurringPayBody,
    pendingRecurringPlan,
    syncPendingRecurringCashMethod,
};
